import React from "react";
import { Fade } from "react-reveal";
import { Link } from "react-router-dom";
import "../App.css";
import "./Service.css";
const OurService = (props) => {
	return (
		<>
			<Fade>
				<div className="col-md-6 col-sm-12 col-lg-4">
					<div className="card mb-4 service-card">
						<Link to={`/${props.serviceID}`}>
							{/* <i class={props.icon}></i> */}
							<img src={props.icon}/>
							<div className="card-body2">
								<h4 className="card-title ">{props.title}</h4>
								<p className="text-muted">{props.text}</p>
							</div>
						</Link>
					</div>
				</div>
			</Fade>
		</>
	);
};
export default OurService;
